import { CAPABILITY_GLOW_SURFACE, ASSISTANT_THREAD_BG } from '../components/shared/prompt-display/chatPanelSurfaces';

/** Prompt wrap, context folder headers — matches builder blue glow panels. */
export const HINT_PANEL_SURFACE = CAPABILITY_GLOW_SURFACE;

/** Shared glow fill + shadow — context read cards and prompt body areas. */
const CONTENT_GLOW_BASE = {
  bgcolor: ASSISTANT_THREAD_BG,
  borderColor: 'rgba(15, 23, 42, 0.08)',
  boxShadow: 'none',
  '&:focus-within': {
    boxShadow: '0 0 0 3px rgba(15, 23, 42, 0.06)',
  },
};

/** 1px section rules — matches other light grey panels (TestTab, execute chrome, etc.). */
export const LIGHT_SECTION_BORDER = '1px solid';
export const LIGHT_SECTION_BORDER_COLOR = 'divider';

/** Outer shell for prompt header + body + tags (builder + prompt modal). */
export const promptCardShellSx = {
  border: LIGHT_SECTION_BORDER,
  borderColor: LIGHT_SECTION_BORDER_COLOR,
  borderRadius: '8px',
  overflow: 'hidden',
};

/** Header / tags chrome stripes. */
export const promptCardChromeSx = {
  bgcolor: 'background.paper',
};

export const promptCardHeaderSx = {
  ...promptCardChromeSx,
  borderBottom: LIGHT_SECTION_BORDER,
  borderColor: LIGHT_SECTION_BORDER_COLOR,
};

export const promptCardFooterSx = {
  ...promptCardChromeSx,
  borderTop: LIGHT_SECTION_BORDER,
  borderColor: LIGHT_SECTION_BORDER_COLOR,
};

/** Prompt body between header/tags (builder + prompt modal). */
export const promptContentGlowEmbeddedSx = {
  bgcolor: ASSISTANT_THREAD_BG,
  overflow: 'hidden',
};

/** Prompt body in full-screen editor dialogs. */
export const promptContentGlowStandaloneSx = {
  bgcolor: 'grey.50',
  border: LIGHT_SECTION_BORDER,
  borderColor: LIGHT_SECTION_BORDER_COLOR,
  borderRadius: '8px',
  overflow: 'hidden',
};

/** Context repository read modal content card. */
export const contextContentCardSx = {
  p: { xs: 2, sm: 2.75 },
  border: '1px solid',
  borderRadius: '8px',
  color: 'text.primary',
  fontSize: '0.92rem',
  lineHeight: 1.6,
  ...CONTENT_GLOW_BASE,
};
